/**
 * @license
 * @copyright Copyright Motili Inc., 2019 All Rights Reserved
 */

import { Component } from 'react';
import PropTypes from 'prop-types';

import * as Validator from 'common/utils/Validator';
import FormTextInput from 'common/components/form/FormTextInput';
import { formInputDefaultProps } from 'common/utils/form-input-utils';

export default class FormManufacturerYearInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isValid: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                isValid:
                    this.props.value || this.props.value === 0
                        ? this.props.validator(this.props.value)
                        : null,
            });
        }
    }

    onChange = (...args) => {
        if (this.props.onChange) {
            this.props.onChange(...args);
        }
    };

    onBlur(...args) {
        this.setState({
            isValid:
                this.props.value || this.props.value === 0
                    ? this.props.validator(this.props.value)
                    : null,
        });

        if (this.props.onBlur) {
            this.props.onBlur(...args);
        }
    }

    getValidationState() {
        if (this.state.isValid === true) {
            return { state: 'success' };
        }

        if (this.state.isValid === null) {
            return { state: null };
        }

        return { state: 'error' };
    }

    render() {
        return (
            <FormTextInput
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...this.props}
                validation={{
                    ...this.getValidationState(),
                    message: this.props.validation.message,
                }}
                onChange={this.onChange}
                onBlur={(...args) => this.onBlur(...args)}
                value={this.props.value}
            />
        );
    }
}

FormManufacturerYearInput.propTypes = {
    ...FormTextInput.propTypes,
    validator: PropTypes.func,
};

FormManufacturerYearInput.defaultProps = {
    ...formInputDefaultProps,
    validator: Validator.isManufacturerYear,
    validation: {
        message: 'Invalid year - must be between 1950 and present year',
    },
    value: '',
};
